import React from "react";
import DateRenderer from "./DateRenderer";

interface DateRangeRendererProps
{
    fromDate: string;
    thruDate: string;
}

export default class DateRangeRenderer extends React.Component<DateRangeRendererProps>
{
    render(): React.ReactNode
    {
        if (!this.props.fromDate && !this.props.thruDate)
            return null;

        return <span>
            <DateRenderer value={this.props.fromDate} type="long" />
            {" - "}
            {
                this.props.thruDate
                    ?
                    <DateRenderer value={this.props.thruDate} type="long" />
                    :
                    <b>Present</b>
            }
        </span>;
    }
}
